<div 
  class="juvo-scroll-container-wrapper" 
  [ngClass]="['scroll-direction-' + direction, 'scroll-size-' + size]"
  [class.hide-scrollbar]="!showScrollable"
>
  <div class="juvo-scroll-container-content">
    <ng-content></ng-content>
  </div>
</div>
